import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/constants";

const MAP = { instagram: Instagram, facebook: Facebook, twitter: Twitter, youtube: Youtube };

export function SocialIcons({ className = "", size = 18 }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {SOCIALS.map((s) => {
        const Icon = MAP[s.icon];
        return (
          <a
            key={s.name}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.name}
            title={s.name}
            data-testid={`social-${s.icon}`}
            className="grid place-items-center h-10 w-10 rounded-full border border-white/10 bg-white/5 text-white/70 transition-all duration-300 hover:text-white hover:border-blaze-orange hover:bg-blaze-orange/15 hover:-translate-y-1"
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
}
